module.exports = __webpack_public_path__ + "img/JopieGerritsen_wolkjes_600x600px.db522057.png";